/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateItemGroupDto } from '../models/work-create-item-group-dto';
import { WorkItemGroup } from '../models/work-item-group';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateItemGroupDto } from '../models/work-update-item-group-dto';

@Injectable({ providedIn: 'root' })
export class WorkItemGroupsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemGroupsV2ControllerFindAllPaginated()` */
  static readonly ItemGroupsV2ControllerFindAllPaginatedPath = '/v2/itemgroups';

  /**
   * Required permissions: itemgroups:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemGroupsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemGroupsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId=$not:$like:John Doe&filter.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.parentId'?: Array<string>;

    /**
     * Filter by childId query param.
     *           <p>
     *              <b>Format: </b> filter.childId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.childId=$not:$like:John Doe&filter.childId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.childId'?: Array<string>;

    /**
     * Filter by budgetPrice query param.
     *           <p>
     *              <b>Format: </b> filter.budgetPrice={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.budgetPrice=$not:$like:John Doe&filter.budgetPrice=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.budgetPrice'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> child.name:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>budgetPrice</li>
     * <li>parent.name</li>
     * <li>child.name</li></ul>
     */
      sortBy?: Array<'budgetPrice:ASC' | 'budgetPrice:DESC' | 'parent.name:ASC' | 'parent.name:DESC' | 'child.name:ASC' | 'child.name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> parent.name,child.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>parent.name</li>
     * <li>child.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkItemGroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'parentId'?: (string | Array<string>);
'childId'?: (string | Array<string>);
'budgetPrice'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemGroupsService.ItemGroupsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.parentId', params['filter.parentId'], {});
      rb.query('filter.childId', params['filter.childId'], {});
      rb.query('filter.budgetPrice', params['filter.budgetPrice'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkItemGroup>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'parentId'?: (string | Array<string>);
        'childId'?: (string | Array<string>);
        'budgetPrice'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: itemgroups:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemGroupsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemGroupsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId=$not:$like:John Doe&filter.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.parentId'?: Array<string>;

    /**
     * Filter by childId query param.
     *           <p>
     *              <b>Format: </b> filter.childId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.childId=$not:$like:John Doe&filter.childId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.childId'?: Array<string>;

    /**
     * Filter by budgetPrice query param.
     *           <p>
     *              <b>Format: </b> filter.budgetPrice={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.budgetPrice=$not:$like:John Doe&filter.budgetPrice=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.budgetPrice'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> child.name:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>budgetPrice</li>
     * <li>parent.name</li>
     * <li>child.name</li></ul>
     */
      sortBy?: Array<'budgetPrice:ASC' | 'budgetPrice:DESC' | 'parent.name:ASC' | 'parent.name:DESC' | 'child.name:ASC' | 'child.name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> parent.name,child.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>parent.name</li>
     * <li>child.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkItemGroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'parentId'?: (string | Array<string>);
'childId'?: (string | Array<string>);
'budgetPrice'?: (string | Array<string>);
};
};
}> {
    return this.itemGroupsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkItemGroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'parentId'?: (string | Array<string>);
'childId'?: (string | Array<string>);
'budgetPrice'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkItemGroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'parentId'?: (string | Array<string>);
'childId'?: (string | Array<string>);
'budgetPrice'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `itemGroupsV2ControllerCreate()` */
  static readonly ItemGroupsV2ControllerCreatePath = '/v2/itemgroups';

  /**
   * Required permissions: itemgroups:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemGroupsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemGroupsV2ControllerCreate$Response(
    params: {
      body: WorkCreateItemGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItemGroup>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemGroupsService.ItemGroupsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItemGroup>;
      })
    );
  }

  /**
   * Required permissions: itemgroups:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemGroupsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemGroupsV2ControllerCreate(
    params: {
      body: WorkCreateItemGroupDto
    },
    context?: HttpContext
  ): Observable<WorkItemGroup> {
    return this.itemGroupsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItemGroup>): WorkItemGroup => r.body)
    );
  }

  /** Path part for operation `itemGroupsV2ControllerFindOneById()` */
  static readonly ItemGroupsV2ControllerFindOneByIdPath = '/v2/itemgroups/{id}';

  /**
   * Required permissions: itemgroups:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemGroupsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemGroupsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItemGroup>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemGroupsService.ItemGroupsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItemGroup>;
      })
    );
  }

  /**
   * Required permissions: itemgroups:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemGroupsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemGroupsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkItemGroup> {
    return this.itemGroupsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItemGroup>): WorkItemGroup => r.body)
    );
  }

  /** Path part for operation `itemGroupsV2ControllerDelete()` */
  static readonly ItemGroupsV2ControllerDeletePath = '/v2/itemgroups/{id}';

  /**
   * Required permissions: itemgroups:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemGroupsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemGroupsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemGroupsService.ItemGroupsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: itemgroups:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemGroupsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemGroupsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.itemGroupsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `itemGroupsV2ControllerUpdate()` */
  static readonly ItemGroupsV2ControllerUpdatePath = '/v2/itemgroups/{id}';

  /**
   * Required permissions: itemgroups:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemGroupsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemGroupsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateItemGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemGroupsService.ItemGroupsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: itemgroups:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemGroupsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemGroupsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateItemGroupDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.itemGroupsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
